import React from 'react'
import {Icon} from '@chakra-ui/react'

const SaveIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M17.7756 3H5.10938C3.94627 3 3 3.94627 3 5.10938V18.8906C3 20.0537 3.94627 21 5.10938 21H18.8906C20.0537 21 21 20.0537 21 18.8906V6.22439L17.7756 3ZM8.51953 4.40625H12.7031V6.375C12.7031 6.76332 13.0179 7.07812 13.4062 7.07812C13.7946 7.07812 14.1094 6.76332 14.1094 6.375V4.40625H15.5156V7.78125C15.5156 8.16895 15.2002 8.48438 14.8125 8.48438H9.22266C8.83495 8.48438 8.51953 8.16895 8.51953 7.78125V4.40625ZM16.9219 19.5938H7.11328V13.4062C7.11328 13.0185 7.4287 12.7031 7.81641 12.7031H16.2188C16.6065 12.7031 16.9219 13.0185 16.9219 13.4062V19.5938ZM19.5938 18.8906C19.5938 19.2783 19.2783 19.5938 18.8906 19.5938H18.3281V13.4062C18.3281 12.2431 17.3819 11.2969 16.2188 11.2969H7.81641C6.6533 11.2969 5.70703 12.2431 5.70703 13.4062V19.5938H5.10938C4.72167 19.5938 4.40625 19.2783 4.40625 18.8906V5.10938C4.40625 4.72167 4.72167 4.40625 5.10938 4.40625H7.11328V7.78125C7.11328 8.94436 8.05955 9.89062 9.22266 9.89062H14.8125C15.9756 9.89062 16.9219 8.94436 16.9219 7.78125V4.40625H17.1931L19.5938 6.80686V18.8906Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SaveIcon
